import React from "react";
import Tabs from "./Tabs";
import TabsTermeChianciano from "./TabsTermeChianciano";
import TabsAlibi from "./TabsAlibi";
import TabsBlueNote from "./TabsBlueNote";

export default function TabRouter(props) {
    const { hasOrders, defaultTab, restaurant } = props;

    if (restaurant.token === "ZHuXyVeu6") {
        return <TabsAlibi></TabsAlibi>;
    }

    if (restaurant.token === "3TxGx9xEs") {
        return <TabsTermeChianciano hasOrders={hasOrders}></TabsTermeChianciano>;
    }

    if (restaurant.token === "IJwpJoOWW") {
        return <TabsBlueNote hasOrders={hasOrders}></TabsBlueNote>;
    }

    return <Tabs hasOrders={hasOrders} defaultTab={defaultTab}></Tabs>;
}
